<template>
	<GlassCard class="p-2">
		<h2 class="p-2">Monthly Caloric Intake Report</h2>
		<input
			type="month"
			v-model="selectedMonth"
			@change="fetchNutritionData"
			v-if="isOnline" />
		<canvas ref="canvas"></canvas>
	</GlassCard>
</template>

<script setup>
	import { ref, watch, onMounted, onBeforeMount, onBeforeUnmount } from "vue"
	import GlassCard from "./GlassCard.vue"
	import Chart from "chart.js/auto"
	import moment from "moment-timezone"
	// import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import { isOnline } from "@/utils/networkBus"

	const selectedMonth = ref(moment().format("YYYY-MM"))
	const nutritionData = ref([])
	const canvas = ref(null)

	// const router = useRouter()
	// const tokenStore = useTokenStore()

	let myChart = null

	async function fetchNutritionData(month) {
		if (typeof month === "string") {
			// console.log(month)
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const [year, monthPart] = month.split("-")
			const response = await fetchWithAuth(
				`/api/report/monthly-caloric-intake?year=${year}&month=${monthPart}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			nutritionData.value = await response.json()

			if (myChart) {
				myChart.destroy()
			}

			myChart = new Chart(canvas.value, {
				type: "line",
				data: {
					datasets: [
						{
							label: "Calories",
							data: nutritionData.value.map((data) => ({
								x: data.day,
								y: data.totalCalories,
							})),
							borderColor: "white",
							backgroundColor: "red",
						},
					],
				},
				options: {
					scales: {
						y: {
							beginAtZero: false,
							ticks: {
								color: "white",
							},
						},
						x: {
							ticks: {
								color: "white",
							},
						},
					},
					plugins: {
						legend: {
							labels: {
								color: "white",
							},
						},
					},
					responsive: true,
				},
			})
			// }
		}
	}

	onMounted(() => {
		// console.log(canvas.value)
		fetchNutritionData(selectedMonth.value)
	})

	watch(
		selectedMonth,
		(newMonth) => {
			fetchNutritionData(newMonth)
		}
		// { immediate: true }
	)

	// watch(lastMealUpdated, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	// watch(lastMealDeleted, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", () => {
			fetchNutritionData(selectedMonth.value)
		})

		offMealDeleted = EventBus.on("meal-deleted", () => {
			fetchNutritionData(selectedMonth.value)
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})
</script>
